// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3340":"7e806f08d1032516","9610":"fcdd0a30ff661f61"}[chunkId] + ".css";
};